module.exports = __webpack_public_path__ + "static/img/政务数字场景金融服务系统dialog.7621c42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/政务数字场景金融服务系统dialog.jpg
// module id = dZ1A
// module chunks = 1